import { Flex } from 'antd';
import './AvatarCustom.scss';

type AvatarCustomProps = {
  size: number | 'small' | 'medium';
  background?: string;
  text: string;
  className?: string;
};

const AvatarCustom = ({ size, background, text, className = '' }: AvatarCustomProps) => {
  const sizeNum = typeof size === 'number' ? size : null;

  return (
    <Flex
      className={`avatar-custom ${className} ${size === 'small' ? 'small' : 'medium'}`}
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.25)',
        backgroundImage: background,
        width: sizeNum || '',
        height: sizeNum || ''
      }}
      justify='center'
      align='center'
    >
      <span>{text}</span>
    </Flex>
  );
};

export default AvatarCustom;
